import { useTranslation } from 'react-i18next';
import { FormatUtils, PermissionUtils } from '@shared/utils';
import type { ProfileResponse } from '@shared/api';
import { SidebarItem, SidebarRow } from '@widgets';
import { Button, Icon } from '@shared/widgets';
import ShieldIcon from '@assets/icons/shield.svg';
import UserIcon from '@assets/icons/user.svg';

interface UserSidebarItemsProps {
  user: ProfileResponse;
  onShowDetailsModal: () => void;
  onShowPasswordModal: () => void;
  onShowLockModal: () => void;
  onShowDeleteModal: () => void;
}

export const UserSidebarItems = (props: UserSidebarItemsProps) => {
  const { t } = useTranslation('user');

  return (
    <>
      <SidebarItem title={t('sidebar.profile.title')} icon={<Icon icon={<UserIcon />} color='inherit' />}>
        <SidebarRow label={t('sidebar.profile.fields.username')} value={props.user.userName} />
        <SidebarRow label={t('sidebar.profile.fields.firstName')} value={props.user.firstName} />
        <SidebarRow label={t('sidebar.profile.fields.lastName')} value={props.user.lastName} />
        {props.user.phoneAreaCode && props.user.phoneNumber && (
          <SidebarRow
            label={t('sidebar.profile.fields.phoneNumber')}
            value={FormatUtils.toPhoneFormat(props.user.phoneAreaCode, props.user.phoneNumber)}
          />
        )}
        <SidebarRow label={t('sidebar.profile.fields.positionRole')} value={props.user.position || t('sidebar.profile.fields.none')} />
        {PermissionUtils.updateUserProfileDetails() && (
          <Button color='outlined' className='mb-5' fullWidth onClick={props.onShowDetailsModal}>
            {t('buttons.editDetails', { ns: 'common' })}
          </Button>
        )}
      </SidebarItem>
      <SidebarItem
        title={t('sidebar.security.title')}
        icon={<Icon icon={<ShieldIcon />} color='inherit' />}
        isHidden={!PermissionUtils.changeUserPassword() && !PermissionUtils.lockOrUnlockUser() && !PermissionUtils.deleteUser()}
      >
        {PermissionUtils.changeUserPassword() && (
          <Button className='mb-5' fullWidth color='outlined' onClick={props.onShowPasswordModal}>
            {t('buttons.changePassword', { ns: 'common' })}
          </Button>
        )}
        {PermissionUtils.lockOrUnlockUser() && (
          <Button className='mb-5' fullWidth color='outlined' onClick={props.onShowLockModal}>
            {props.user.locked ? t('sidebar.security.buttons.unlockUser') : t('sidebar.security.buttons.lockUser')}
          </Button>
        )}
        {PermissionUtils.deleteUser() && (
          <Button className='mb-5' fullWidth color='outlined' onClick={props.onShowDeleteModal}>
            {t('sidebar.security.buttons.deleteUser')}
          </Button>
        )}
      </SidebarItem>
    </>
  );
};
